import { Text } from "@redotech/redo-web/text";
import { memo } from "react";

/**
 * Renders a macro variable's `displayName` as a single line, with any
 * leading shared prefix (e.g. "Recent Order:") in a muted tertiary color
 * and the unique tail in the default text color. Splits on the first
 * ": " sequence — display names without that pattern render as one piece.
 *
 * Matches the styling of `RedoListItem type="text"` items so we can drop
 * this inside `RedoListItem type="custom"` and not visually diverge from
 * the rest of the list.
 */
export const VariableLabel = memo(function VariableLabel({
  displayName,
}: {
  displayName: string;
}) {
  const idx = displayName.indexOf(": ");
  if (idx === -1) {
    return (
      <Text
        fontSize="xs"
        fontWeight="medium"
        overflow="hidden"
        textOverflow="ellipsis"
        whiteSpace="nowrap"
      >
        {displayName}
      </Text>
    );
  }
  const prefix = displayName.slice(0, idx);
  const rest = displayName.slice(idx + 2);
  return (
    <Text
      fontSize="xs"
      fontWeight="medium"
      overflow="hidden"
      textOverflow="ellipsis"
      whiteSpace="nowrap"
    >
      <Text as="span" fontWeight="regular" textColor="secondary">
        {prefix}:{" "}
      </Text>
      <Text as="span">{rest}</Text>
    </Text>
  );
});
